import request from '@/utils/request'

// 分页查询线索列表
export function queryClueList(data) {
  return request({
    url: '/crmClue/queryList',
    method: 'post',
    data: data
  })
}

// 分页查询线索列表
export function queryClueDetail(query) {
  return request({
    url: '/crmClue/queryDetail',
    method: 'get',
    params: query
  })
}

// 校验手机号
export function checkCluePhoneNum(query) {
  return request({
    url: '/crmClue/checkCluePhoneNum',
    method: 'get',
    params: query
  })
}

// 新增线索
export function addClue(data) {
  return request({
    url: '/crmClue/addClue',
    method: 'post',
    data: data
  })
}

// 更新线索
export function updateClue(data) {
  return request({
    url: '/crmClue/update',
    method: 'put',
    data: data
  })
}

// 查询当前用户的线索创建策略
export function queryClueCreatePolicy() {
  return request({
    url: '/crmClue/createPolicy',
    method: 'get'
  })
}

// 提交线索审批
export function submitClueApproval(data) {
  return request({
    url: '/crmClue/submitApproval',
    method: 'post',
    data: data
  })
}

// 撤回线索审批
export function withdrawClueApproval(data) {
  return request({
    url: '/crmClue/withdrawApproval',
    method: 'post',
    data: data
  })
}

// 驳回后重新提交线索审批
export function resubmitClueApproval(data) {
  return request({
    url: '/crmClue/resubmitApproval',
    method: 'post',
    data: data
  })
}

// 线索转商机
export function convertToBusiness(data) {
  return request({
    url: '/crmClue/convertToBusiness',
    method: 'post',
    data: data
  })
}

// 关闭线索
export function closeClue(data) {
  return request({
    url: '/crmClue/closeClue',
    method: 'put',
    data: data
  })
}

// 恢复线索
export function openClue(data) {
  return request({
    url: '/crmClue/openClue',
    method: 'put',
    data: data
  })
}
